import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
// import { Link } from 'react-router-dom';
import { FormInput } from '../form';
import SwiperSlider3 from '../sliders/SwiperSlider3';
import Swal from 'sweetalert2';

const Hero11 = () => {
    // handle form submission
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = {
            name: (e.target as any).name.value,
            email: (e.target as any).email.value,
        };

        console.log('Form data:', formData); // Debugging: Log form data

        fetch('https://formspree.io/f/xwkgwnke', {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                console.log('Response:', response); // Debugging: Log response
                if (response.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'We will get back to you shortly!',
                    });
                } else {
                    throw new Error('Failed to send form.');
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to send information. Please try again.',
                });
            });
    };

    return (
        <section className="position-relative hero-11 py-1 pt-7 pb-sm-6">
            <Container className="hero-content">
                <Row className="align-items-center">
                    <Col xs={12} className="text-center">
                        <h1 className="hero-title">
                            Simplify Your Workflow, <span className="highlight highlight-success d-inline-block">Maximize</span>{' '}
                            Revenue!
                        </h1>
                        <p className="fs-17 text-muted pt-0">
                            Effortlessly optimize your operations with our streamlined management solution.
                        </p>
                        <div className="mt-4 mt-sm-5 pt-0 d-flex align-items-center justify-content-center">
                            <form onSubmit={onSubmit}>
                                <Row className="g-2 text-start">
                                    <Col sm={4}>
                                        <FormInput
                                            type="text"
                                            className="form-control mb-2 me-sm-2 shadow-sm"
                                            name="name"
                                            id="name"
                                            placeholder="Your Name"
                                            required
                                        />
                                    </Col>
                                    <Col sm={4}>
                                        <FormInput
                                            type="email"
                                            className="form-control mb-2 me-sm-2 shadow-sm"
                                            name="email"
                                            id="email"
                                            placeholder="Your Email"
                                            required
                                        />
                                    </Col>
                                    <Col sm={4}>
                                        <Button type="submit" className="mb-2">Sign Up</Button>
                                    </Col>
                                </Row>
                            </form>
                        </div>
                        <div className="d-flex mt-2 justify-content-center">
                            <div className="me-4">
                                <FeatherIcon icon="check-circle" className="icon icon-dual-success icon-xs me-1" />
                                Enhancing revenue stream
                            </div>
                            <div className="me-4">
                                <FeatherIcon icon="check-circle" className="icon icon-dual-success icon-xs me-1" />
                                Map Based View
                            </div>
                            <div>
                                <FeatherIcon icon="check-circle" className="icon icon-dual-success icon-xs me-1" />
                                Boost efficiency
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="feature-container position-relative overflow-hidden mt-5 mb-4">
                <Container>
                    <Row className="align-items-center justify-content-center zindex-1 slider-container">
                        <Col xs={10} className="text-center zindex-1">
                            <Card className="rounded-lg shadow" data-aos="fade-up" data-aos-duration="2000">
                                <Card.Body className="slider-container-body">
                                    <div className="slider">
                                        <SwiperSlider3 />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    );
};

export default Hero11;
